var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThree = function SvgThree(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 0H2.68034C1.21367 0 0.0136719 1.2 0.0136719 2.66667V21.3333C0.0136719 22.8 1.21367 24 2.68034 24H21.3337C22.8003 24 24.0003 22.8 24.0003 21.3333V2.66667C24.0003 1.2 22.8003 0 21.3337 0ZM16.0137 10C16.0137 11.1067 15.1203 12 14.0137 12C15.1203 12 16.0137 12.8933 16.0137 14V16C16.0137 17.48 14.8137 18.6667 13.347 18.6667H9.33367C8.60034 18.6667 8.00034 18.0667 8.00034 17.3333C8.00034 16.6 8.60034 16 9.33367 16H13.347L13.3337 13.3333H12.0003C11.267 13.3333 10.667 12.7333 10.667 12C10.667 11.2667 11.267 10.6667 12.0003 10.6667H13.3337L13.347 8H9.33367C8.60034 8 8.01367 7.4 8.01367 6.66667C8.01367 5.93333 8.60034 5.33333 9.33367 5.33333H13.347C14.8137 5.33333 16.0137 6.53333 16.0137 8V10Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThree, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/three.754b54b3.svg";
export { ForwardRef as ReactComponent };